<template>
  <div v-if="false"></div>
</template>

<script>
import ClusterSource from "ol/source/Cluster";

import GeoJSON from "ol/format/GeoJSON";
import VectorSource from "ol/source/Vector";
import SelectCluster from "ol-ext/interaction/SelectCluster";
import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import Feature from "ol/Feature";
import { getStyle, getClusterStyle } from "../../styles";

const geoJSON = new GeoJSON();

export default {
  name: "VectorLayer",
  inject: ["map"],
  created() {
    this.vectorSource = new VectorSource();

    this.clusterSource = new ClusterSource({
      distance: 25,
      minDistance: 10,
      source: this.vectorSource,
    });

    this.vectorLayer = new AnimatedCluster({
      name: this.name,
      source: this.clusterSource,
      animationDuration: 700,
      style: (feature) => {
        if (feature.get("features").length > 1) {
          return getClusterStyle(feature.get("features").length, false);
        }

        return getStyle(
          this.map,
          this.styleName,
          feature.get("features")[0],
          false
        );
      },
      properties: {
        selectable: this.selectable,
      },
    });

    const selectCluster = new SelectCluster({
      pointRadius: 15,
      animate: false,
      autoClose: true,
      selectCluster: true,
      featureStyle: (f) => {
        var cluster = f.get("features");
        if (cluster && cluster.length > 0) {
          return getStyle(this.map, this.styleName, cluster[0], false);
        }
      },
      style: (f, res) => {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getClusterStyle(cluster.length, false);
        }

        return getStyle(this.map, this.styleName, cluster[0], true);
      },
    });

    selectCluster.getFeatures().on(["add"], (e) => {
      const c = e.element.get("features");
      if (c.length === 1) {
        const feature = c[0];
        this.$emit("select", {
          ...feature.getProperties(),
          geometry: geoJSON.writeGeometryObject(feature.getGeometry()),
        });
      }
    });

    this.map.addInteraction(selectCluster);

    this.loadFeatures(this.features);
    this.map.addLayer(this.vectorLayer);
  },
  unmounted() {
    this.map.getLayers().forEach((layer) => {
      if (layer.get("name") === this.vectorLayer.get("name")) {
        this.map.removeLayer(layer);
      }
    });
  },
  props: {
    name: String,
    features: Array,
    styleName: String,
    selectable: Boolean,
  },
  watch: {
    features(features) {
      this.loadFeatures(features);
    },
  },
  methods: {
    loadFeatures(features) {
      if (this.vectorSource) {
        this.vectorSource.clear();
      }

      this.vectorSource.addFeatures(
        features.map((feature) => {
          const constructedFeature = new Feature({
            ...feature,
            geometry: geoJSON.readGeometry(feature.geometry),
          });

          constructedFeature.setId(feature.id);

          return constructedFeature;
        })
      );
    },
  },
};
</script>

<style scoped></style>
